<template>
    <div>
      <modal :title="$t('Drivers.default_order')" @close-request="$emit('closeModal')" closable>
        <div>
          <table-element :fields="fieldsObj" :arrOfElement="arrOfFiles" :sortSpacing="0" :isShowFilter="false"
           class="card mx-2 mt-4" :isDraggable="true" @updateFinalData="updateFinalData" :sortable="false" :pageSize="1000">
            <template #body-content-desktop="content" >
              <!-- files -->
              <tr v-for="(item) in content.results" :id="item.id" :key="item.name"
              class="table-element_hover text-center draggable-item">
                <td>
                  <div class="item-with-handle">
                    <i class="mx-2 fa fa-solid fa-bars drag-handle" />
                    <div class="item-name nowrap" style="position: relative">
                      <span>{{ item.name }}</span>
                      <span ref="hoverIcon" id="hoverIcon" v-if="!checkIconText"
                        class="icon--hover" aria-hidden="true" @mouseenter="e => mouseMoveXY(e.clientX, e.clientY)"
                        @click="onClickCopy(text)">
                        <span class="fa fa-info-circle icon-color icon-background-color"
                          :style="returnIconCSS"></span>
                        <div class="icon--tooltip tooltip-bottom tooltip-left" :style="{ width: getToolTipWidth(item) }" >
                          <i class="text-width" v-html="renderedText(item)" />
                        </div>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
  
            <template #body-content-mobile="content">
              <!-- files -->
              <div v-for="(item) in content.results" :id="item.id" :key="item.id" class="card p-2  my-3 mx-2 draggable-item">
                <h4 style="text-align: center;">{{ item.name }}</h4>
                <div v-if="fileType==='driverfile'">
                  <h6>{{$t('Drivers.driver_name')}} :</h6>
                  <p>{{item.driverName || ''}}</p>
                </div>
                <div v-if="fileType==='clientfile'">
                  <h6>{{$t('Clients.client_name')}} :</h6>
                  <p>{{item.clientName || ''}}</p>
                </div>
                <div class="d-flex justify-content-center my-3">
                  <i class="mx-2 fa fa-solid fa-bars drag-handle" />
                </div>
              </div>
            </template>
  
            <template #post-body-content>
              <div class="mt-2">
                <button @click="handleConfirm" class="float-right btn btn-kne-orange m-1">
                  {{ $t('OrderCurrent.modal.confirm') }}
                </button>
                <button @click="$emit('closeModal')" class="float-right btn btn-danger m-1">{{
                  $t('OrderCurrent.modal.cancel') }}</button>
              </div>
            </template>
          </table-element>
        </div>
        <loading-render v-if="isLoading" />
      </modal>
    </div>
  </template>
  
  <script>
  import Modal from '../../interface-components/Modal.vue'
  import hoverToolTip from '../../basic-components/hoverToolTip.vue'
  import DistributedHistoryModal from './DistributedHistory-modal.vue'
  import DeliveryLocationModal from './DeliveryLocation-modal.vue'
  import TableElement from '../Table-component/Table-Element.vue'
  import LoadingRender from '../Other-components/LoadingRender.vue'
  import { db } from '../../../../firebase'
  
  export default {
    name: 'DefaultOrderModal',
    components: {
      Modal,
      hoverToolTip,
      DistributedHistoryModal,
      DeliveryLocationModal,
      TableElement,
      LoadingRender
    },
    props: {
      arrOfFiles: {
        type: Array,
        required: true
      },
      fileType: String,
      isOpen: Boolean
    },
  
    data () {
      return {
        isFeedbackPlay: false,
        mouseX: 270,
        mouseY: 550,
        fieldsObj: [
          {
           text: this.$t('Drivers.file_name'),
           type: 'name',
           value: ''
          }
        ],
        zones: [],
        adminData: [],
        finalData: this.arrOfFiles.slice().toReversed() || [],
        isLoading: true
      }
    },
    async mounted () {
      this.isLoading = false
    },
    methods: {
      mouseMoveXY (x, y) {
        if (!this.displayFixed) return
        this.mouseX = x
        this.mouseY = y
      },
  
      /** Copy the content of a tooltip to the clipboard if allowed in the props options */
      onClickCopy () {
        if (!this.clickable) return
        let fakeText = this.text
  
        fakeText = this.trimSpaces(fakeText)
        fakeText = this.trimSpecialChars(fakeText)
        navigator.clipboard.writeText(fakeText)
        this.playFeedback()
      },
  
      /** After calling @function onClickCopy - Show a feedback tooltip and then switch back after a delay */
      playFeedback () {
        this.isFeedbackPlay = true
  
        setTimeout(() => {
          this.isFeedbackPlay = false
        }, 1000)
      },
  
      /** Remove unecessary spaces */
      trimSpaces (text) {
        text = text.replace(/ {2}/g, '')
        text = text.trim()
  
        return text
      },
  
      /** Remove unecessary characters */
      trimSpecialChars (text) {
        text = text.replace(/<.*>/g, '')
  
        return text
      },
      renderedText (item) {
        if (this.isFeedbackPlay) return this.$t('hoverToolTip.copied')
        else return this.trimSpaces(this.getToolTipData(item))
      },
      getToolTipWidth (fileItem) {
        // minimum tooltop width
        let pickZonesCh = 20
        let dropZonesCh = 20
        // if tooltip has max width then make it wrap the text
        if (fileItem.pickZonesByName) {
          pickZonesCh = fileItem.pickZonesByName.join(', ').length
          if (pickZonesCh > 90) {
            return '37vw'
          }
        }
        if (fileItem.dropZonesByName) {
          dropZonesCh = fileItem.dropZonesByName.join(', ').length
          if (dropZonesCh > 90) {
            return '37vw'
          }
        }
        // else choose width based on the number of characters
        if (pickZonesCh > dropZonesCh) {
          return `${(pickZonesCh + 2) * 2}ch`
        }
        return `${(dropZonesCh + 2) * 2}ch`
      },
      getToolTipData (fileItem) {
        let text = ''
        if (this.fileType === 'driverfile') {
          text += `<div"><strong>${this.$t('Drivers.driver_name')}:</strong></div>`
          text += `<p>${fileItem.driverName || ''}</p>`
        } else if (this.fileType === 'clientfile') {
          text += `<div"><strong>${this.$t('Clients.client_name')}:</strong></div>`
          text += `<p>${fileItem.clientName || ''}</p>`
        }
        return text
      },
      handleConfirm () {
        // update the index fields
        const newData = this.finalData.map((item, index) => {
          item.index = (index + 1000)
          return item
        })
        this.updateFinalData(newData)
        this.saveAllData(newData)
      },
      updateFinalData (newData) {
        this.finalData = [...newData]
      },
      async saveAllData (newData) {
        // create a bulk update object
        const updates = {}
        for (const item of newData) {
          const itemCopy = { ...item }
          const path = `database/${this.fileType}s/transporter/${this.companyUID}/${this.fileType}/${itemCopy.id}/index`
          updates[path] = itemCopy.index
        }
        try {
          await db.ref().update(updates)
          console.log('Default order update successful')
          this.closeModal()
        } catch (error) {
          console.error('Error updating default order:', error)
        }
      },
      closeModal () {
        this.$emit('closeModal')
      }
    },
    computed: {
      companyUID () {
        return this.$store.state.authorization.company
      },
  
      uid () {
        return this.$store.state.user.uid
      },
      checkIconText () {
        if (this.iconText === false || this.iconText === '' || typeof this.iconText === 'undefined') return false
        else return true
      },
  
      returnIconCSS () {
        return {
          '--icon-color': this.iconColor,
          '--icon-background-color': this.iconBackgroundColor
        }
      },
      returnToolTipPosition () {
        return {
          'position': 'fixed',
          'top': (this.mouseY) + 'px',
          'left': (this.mouseX) + 'px'
        }
      }
    }
  }
  </script>
  
  <style scoped>
     .tab{
      display:flex;
      gap:2rem;
      padding-inline:.75rem;
      padding-top:.75rem;
      color:grey;
     }
     .tab>div{
      cursor: pointer;
      width:50%;
      line-height: 2rem;
      text-align: center;
     }
     .tab>div:last-child{
       padding-bottom:.25rem;
       border-left:2px solid rgba(223, 217, 217, 0.527);
      }
      .active-tab{
        font-weight: bold;
        color:black;
     }
     .modal-container{
       display: flex;
       gap:1rem;
      }
    
     .item-with-handle{
      display: flex;
     }
     .item-name{
      margin-inline:auto;
     }
  
    .icon--hover {
      color: #f7941e;
      position: relative;
      text-align: center;
    }
  
    .icon--hover .icon--tooltip {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 0.8rem;
      background: #e88b1a;
      border-radius: 3px;
      color: white;
      margin-bottom: 10px;
      opacity: 0;
      padding: 8px;
      pointer-events: none;
      text-wrap: wrap;
      -webkit-transform: translateY(10px);
      -moz-transform: translateY(10px);
      -ms-transform: translateY(10px);
      -o-transform: translateY(10px);
      transform: translateY(10px);
      -webkit-transition: all .25s ease-out;
      -moz-transition: all .25s ease-out;
      -ms-transition: all .25s ease-out;
      -o-transition: all .25s ease-out;
      transition: all .25s ease-out;
      -webkit-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
      -moz-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
      -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
      -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
      box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    }
    .icon--tooltip {
      position: absolute;
      z-index: 999999;
    }
    
    .tooltip-bottom {
      top: 80%;
    }
    .tooltip-left {
      left: 0%;
    }
  
    .strong {
      font-weight: 900;
    }
    .icon--hover:hover .icon--tooltip {
      opacity: 1;
      pointer-events: auto;
      -webkit-transform: translateY(0px);
      -moz-transform: translateY(0px);
      -ms-transform: translateY(0px);
      -o-transform: translateY(0px);
      transform: translateY(0px);
    }
    .background-thing {
      font-size: 0.8rem;
      background-color: rgb(255, 255, 255);
      border-radius: 5rem;
      padding: 0.25rem 0.25rem 0.25rem 0.25rem;
    }
  
    .icon-color {
      color: var(--icon-color);
    }
  
    .icon-background-color {
      background-color: var(--icon-background-color)
    }
  </style>
